export const toggleCirclesAnimation = (start) => {
  const circles = document.querySelectorAll('.animate-chip-circles');
  const fn = start ? 'beginElement' : 'endElement';
  if (circles?.length) {
    [...circles].forEach((circleAnim) => circleAnim?.[fn]());
  }
};